import styled from "styled-components";

export const Container = styled.main`
  padding: 20px;
  margin: 0 auto;
`;